<template>
  <div class="content">
    <iframe
      :src="reportUrl"
      frameborder="0"
      style="width: 100%; height: 100%"
      id="iframeBox"
      class="iframeBox"
    ></iframe>

    <div class="fixed-add-btn">
      <div class="circle">
        <div v-if="questionbut">
          <p v-if="compile" @click="editQuestion">{{$t('translateText.qpll.bj')}}</p>
          <p @click="viewQuestion">{{text}}</p>
        </div>
        <p   @click="back">{{$t('translateText.qpll.fh')}}</p>
        <p v-if="isfinish"   @click="finish">{{$t('translateText.qpll.qd')}}</p>
        <!-- <a-button type="primary"> 编辑 </a-button>
        <a-button type="primary"> 题目 </a-button> -->
      </div>
    </div>
    <div
      class="panel"
      :class="{
        active: panelShow,
      }"
    >
      <div class="panel-head">
        <a-icon type="file" style="color: white" theme="filled" /><span
          style="padding-left: 10px"
          >{{$t('translateText.qpll.tmyq')}}</span
        >
      </div>
      <div class="panel-content">
        <ul>
          <li
            v-for="(itme, index) in optionarr"
            :key="index"
          >{{option[index]}}</li>
        </ul>
      </div>
    </div>
    <div
      class="panel"
      :class="{
        active: editPanelShow,
      }"
    >
      <div class="panel-head">
        <a-icon type="file" style="color: white" theme="filled" /><span
          style="padding-left: 10px"
          >{{$t('translateText.qpll.bjtm')}}</span
        >
      </div>
      <div class="panel-content">
        <p>
          <span>{{$t('translateText.qpll.xx')}}</span>
          <a-icon
            @click="addoption"
            style="margin-left: 20px; font-size: 20px; color: green"
            type="plus-square"
          />
          <a-icon
            @click="deloption"
            style="margin-left: 20px; font-size: 20px; color: red"
            type="minus-circle"
          />
        </p>

        <!-- <textarea placeholder="请输入题目内容" ref="option" v-model="option[index]" :rows="4" /> -->
        <ul>
          <li
            v-for="(itme, index) in optionarr"
            :key="index"
            style="border: none"
          >
            <textarea
              :placeholder="$t('translateText.qpll.qstm')"
              ref="option"
              v-model="option[index]"
              :rows="4"
              style="width: 90%"
            />
            <span
              @click="dellist(index)"
              style="margin-left: 2%; cursor: pointer"
              ><a-icon type="close"
            /></span>
          </li>
        </ul>
        <a-button type="primary" @click="saveQuestion"> {{$t('translateText.qpll.bc')}} </a-button>
      </div>
    </div>
  </div>
</template>
<script>
// import { GlobalConfig } from "../../../public/static/config";
export default {
  data() {
    return {
      reportUrl: "",
      path: "", //当前切片地址
      key: "Notification",
      open: false,
      editPanelShow: false,
      panelShow: false, //题目面板
      optionarr: [0], //选项数组
      option: [], //选项
      text:"",
    };
  },
  props: {
    slideId: {
      type: Number,
      default: 0,
    },
    courseId: {
      type: Number,
      default: 0,
    },
    questionId: {
      type: Number,
      default: 0,
    },
    courseFileId: {
      type: Number,
      default: 0,
    },
    userId: {
      type: Number,
      default: 0,
    },
    otherUserId: {
      type: Number,
      default: 0,
    },
    p: {
      type: String,
      default: "",
    },
    opentions: {
      type: Array,
      default: () => [],
    },
    questionAnswerId: {
      type: Number,
      default: 0,
    },
    compile:{
      type:Boolean,
      default:true
    },
    questiontype:{
      type: Number,
      default: 0,
    },
    isfinish:{
      type: Boolean,
      default: false,
    },
    questionbut:{
      type: Boolean,
      default: true,
    },
  },
  methods: {
    //确定
    finish(){
      this.$emit("finish")
    },
    
    //返回
    back(){
      this.$emit("back")
    },
    //编辑题目
    editQuestion() {
      this.panelShow = false;
      this.editPanelShow = !this.editPanelShow;
    },
    //浏览题目
    viewQuestion() {
      this.editPanelShow = false;
      this.panelShow = !this.panelShow;
    },
    //添加选项
    addoption() {
      this.optionarr.push(this.optionarr.length);
    },
    //删除选项
    deloption() {
      if (this.optionarr.length == 1) {
        this.$message.success(this.$t('translateText.qpll.zsytm'));
        return;
      }
      let num = this.optionarr.length - 1;
      this.optionarr.splice(num, 1);
    },
    dellist() {
      if (this.optionarr.length == 1) {
        this.$message.success(this.$t('translateText.qpll.zsytm'));
        return;
      }
      let num = this.optionarr.length - 1;
      this.optionarr.splice(num, 1);
      this.option.splice(num, 1);
    },
    //保存题目
    saveQuestion(){
          this.editPanelShow=false
    }
  },
  created() {
    if(this.questiontype == 7){
      this.text = this.$t('translateText.qpll.da')
    }else{
      this.text = this.$t('translateText.qpll.tm')
    }
    this.opentions.map((item)=>{
      this.optionarr.push(item);
    })

    let opentions=this.opentions;
    this.option=opentions;
    console.log(this.option);
    let slideId = this.slideId;
    let courseFileId = this.courseFileId;
    let questionId = this.questionId;
    let userId = this.userId;
    let otherUserId = this.otherUserId;
    let permissions = this.p;
    let questionAnswerId = this.questionAnswerId
    let roleId = this.$store.state.userinfo.role.iRoleId
    let language = this.$i18n.locale
    this.reportUrl = (
     window.GlobalConfig.viewerUrl +
      "?slideId=" +
      slideId +
      "&courseFileId=" +
      courseFileId +
      "&questionId=" +
      questionId +
      "&userId=" +
      userId +
      "&roleId=" +
      roleId +
      "&p=" +
      permissions +
      "&otherUserId=" +
      otherUserId +
      "&questionAnswerId=" +
      questionAnswerId +
      "&language="+
      language +
      "&platform=2" 
    ).trim();
  },
  mounted() {},
  watch:{
    'question.iScore'(){
      if(this.question.iScore == ""){
        this.question.iScore = 0
      }
      if(this.questionAnswerScore < this.question.iScore){
        this.question.iScore = 0
        return this.$message.error(this.$t('translateText.qpll.cczf'))
      }
    }
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  margin: 0 0%;
  position: relative;
  overflow: hidden;
}
.fixed-add-btn {
  position: absolute;
  bottom: 10px;
  right: 0px;
  cursor: pointer;
  opacity: 0.75;
  z-index: 1000;
}
.fixed-add-btn .circle {
  width: 50px;
  /* border-radius: 100%; */
  text-align: center;
  /* box-shadow: 0 2px 10px 0 #57bec2;
  background: #4fbec2; */
  color: #fff;
  position: relative;
  z-index: 2;
}
.fixed-add-btn .circle p {
  box-shadow: 0 2px 10px 0 #2faeb6;
  background: #27acb4;
  padding: 5px;
  margin-top: 10px;
}
.panel {
  position: absolute;
  top: 0;
  right: 50px;
  background: white;
  width: 300px;
  height: 300px;
  overflow-y: auto;
  box-shadow: 0 2px 7px 0px #bfbfbf;
}
.panel-head {
  height: 40px;
  line-height: 40px;
  background: #34adb5;
  color: white;
  text-align: left;
  padding: 0px 10px;
}
.panel-content {
  padding: 10px;
}
.panel-content li {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
.panel {
  -webkit-transform: translateX(20%);
  -moz-transform: translateX(20%);
  -ms-transform: translateX(20%);
  transform: translateX(20%);
  /* opacity: 0; */
  right: -300px;
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}

.active.panel {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
  right: 50px;
  /* opacity: 1; */
}
</style>
